// compare-plans.tsx
import React from 'react';
import { Title, CancelBtn } from '../../account/account-settings.styled';
import { VSpace } from '../../account/account-settings';
import { FeatureListWrap, DescriptionList, Divider } from '../billing.styled';
import { OnboardBtn } from '../../profile/profile.styled';
import {
  ComparePlansWrapper,
  Footer,
  PlanCard,
  BulletItem,
  PlanHeaderRow,
  BestValueBadge,
  PricingMutedText,
  PricingMutedLabel,
  SavingSubTitle,
  UpsellTitle,
} from './compare-plans.styled';

import { useComparePlans, ComparePlansProps } from './compare-plans.hooks';
import { Badge } from '../modals/upgrade-now/upgrade-now.styled';
import { PLANS, formatDollars } from '../billing.constants';

export const ComparePlansPanel: React.FC<ComparePlansProps> = (props) => {
  const { handleGoBack, handleUpgradeToNorthStar, sanctumFeatures, northStarUpsellFeatures } =
    useComparePlans(props);

  const s = PLANS.sanctum.pricing;
  const ns = PLANS.northStar.pricing;

  return (
    <>
      <ComparePlansWrapper>
        {/* Sanctum Plan */}
        <PlanCard>
          <PlanHeaderRow>
            <Title>Sanctum</Title>
            <Badge>Current Plan</Badge>
          </PlanHeaderRow>

          <VSpace $h={16} />
          <Title>{formatDollars(s.annualMonthly)}/mo</Title>
          <VSpace $h={4} />

          <PricingMutedText>{formatDollars(s.annualTotal)} billed at outset of 12-month subscription</PricingMutedText>

          <VSpace $h={4} />
          <SavingSubTitle>Saving {formatDollars(s.annualSavings)} per annum</SavingSubTitle>

          <VSpace $h={16} />
          <FeatureListWrap>
            <DescriptionList>
              {sanctumFeatures.map((text, idx) => (
                <BulletItem key={idx}>{text}</BulletItem>
              ))}
            </DescriptionList>
          </FeatureListWrap>
        </PlanCard>

        {/* North Star Plan */}
        <PlanCard>
          <PlanHeaderRow>
            <Title>North Star</Title>
            <BestValueBadge>Best value</BestValueBadge>
          </PlanHeaderRow>

          <VSpace $h={16} />
          <PricingMutedLabel>Annual pricing</PricingMutedLabel>
          <VSpace $h={4} />
          <Title>{formatDollars(ns.annualMonthly)}/mo</Title>
          <VSpace $h={4} />

          <PricingMutedText>{formatDollars(ns.annualTotal)} billed at outset of 12-month subscription</PricingMutedText>

          <VSpace $h={4} />
          <SavingSubTitle>Saving {formatDollars(ns.annualSavings)} per annum</SavingSubTitle>

          <VSpace $h={4} />
          <Divider />

          <VSpace $h={4} />
          <PricingMutedLabel>Monthly pricing</PricingMutedLabel>
          <VSpace $h={4} />
          <Title>{formatDollars(ns.monthly)}/mo</Title>
          <VSpace $h={4} />

          <PricingMutedText>{formatDollars(ns.monthly)} billed each month</PricingMutedText>

          <VSpace $h={16} />
          <UpsellTitle>You get everything in Sanctum, plus:</UpsellTitle>

          <VSpace $h={12} />
          <FeatureListWrap>
            <DescriptionList>
              {northStarUpsellFeatures.map((text, idx) => (
                <BulletItem key={idx}>{text}</BulletItem>
              ))}
            </DescriptionList>
          </FeatureListWrap>

          <VSpace $h={44} />
          <OnboardBtn style={{ width: '100%' }} onClick={handleUpgradeToNorthStar}>
            Upgrade to North Star
          </OnboardBtn>
        </PlanCard>
      </ComparePlansWrapper>

      <Footer>
        <CancelBtn onClick={handleGoBack}>Go back</CancelBtn>
      </Footer>
      <VSpace $h={4} />
    </>
  );
};
